import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { getLeaderboard } from 'utils/LeaderboardAPI';
import { isLeaderboard, LeaderboardEntry, getLeaderboardConfig } from 'types/Leaderboard';
import { routes } from '../routing/routes';

type RenderedLeaderboard = {
  entries: LeaderboardEntry[];
  title: string;
  subTitle: string;
  hideBreakerStatus?: boolean;
};

export default function useLeaderboard(type?: string) {
  const [isLoading, setIsLoading] = useState(true);
  const [leaderboard, setLeaderboard] = useState<RenderedLeaderboard>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!type || !isLeaderboard(type)) {
      navigate(routes['404']());
      return;
    }

    const handleError = (error: unknown) => {
      if (error instanceof Error) {
        if (error.message === 'The resource could not be found.') {
          navigate('404');
          return;
        }
      }

      throw error;
    };

    const fetchData = async () => {
      try {
        const entries = await getLeaderboard(type);
        setLeaderboard({
          entries,
          ...getLeaderboardConfig(type),
        });
        setIsLoading(false);
      } catch (e) {
        handleError(e);
      }
    };

    fetchData();
  }, [type, navigate]);

  return {
    isLoading,
    leaderboard,
  };
}
